import {  defineComponent, inject, type SetupContext } from "vue";
import { useI18n } from "vue-i18n";
import html_iway from "./template.iway.html?raw";
import { PriceFormatter, priceFormatterKey } from "../../../infrastructure/price_formatter";
import OptionsPhoneHardware from "../OptionsPhoneHardware";
import OptionsPhoneOptions from "../OptionsPhoneOptions";
import OptionsPhoneAccessories from "../OptionsPhoneAccessories";
import OptionsPhoneChannel from "../OptionsPhoneChannel";
import OptionsPhoneSla from "../OptionsPhoneSla";
const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("iway" == app_theme) {
  html = html_iway;
} else if ("lic" == app_theme) {
  html = html_iway;
} else if ("sak" == app_theme) {
  html = html_iway;
}

export default defineComponent({
  template: html,
  components: { OptionsPhoneHardware, OptionsPhoneOptions, OptionsPhoneAccessories, OptionsPhoneChannel, OptionsPhoneSla},
  emits: {
    next: () => true,
  },
  setup(_props: any, { emit }: SetupContext) {
    const { t } = useI18n();
    const priceFormatter = inject<PriceFormatter>(priceFormatterKey)


    const next = () => {
      emit("next");
    };

    return {
      t,
      priceFormatter,
      next,
    };
  },
} as any);

